import { render, staticRenderFns } from "./VueOfficeView.vue?vue&type=template&id=e960e3ee&scoped=true&"
import script from "./VueOfficeView.vue?vue&type=script&lang=js&"
export * from "./VueOfficeView.vue?vue&type=script&lang=js&"
import style0 from "./VueOfficeView.vue?vue&type=style&index=0&id=e960e3ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e960e3ee",
  null
  
)

export default component.exports